import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-partner-layout',
    template: `
    <app-partnernav class="app-wrapper"></app-partnernav>
  `,
    styles: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PartnerLayoutComponent {}
